import { useState, useEffect } from "react";
import { getAllGroups } from "../services/groupsService";
import { Group } from "../types";

export const useGroups = () => {
    const [groups, setGroups] = useState<Group[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const data = await getAllGroups();
                console.log('Fetched groups data:', data);

                // Ensure we always set an array
                if (Array.isArray(data)) {
                    setGroups(data);
                } else if (data && typeof data === 'object') {
                    // If the API returns an object with a groups property
                    const dataObj = data as any;
                    setGroups(Array.isArray(dataObj.groups) ? dataObj.groups : []);
                    console.warn('API returned unexpected format, expected array but got:', data);
                } else {
                    setGroups([]);
                    console.error('API returned unexpected data type:', typeof data);
                }
            } catch (err) {
                console.error('Error fetching groups:', err);
                setError(err instanceof Error ? err.message : "Failed to fetch groups");
                setGroups([]); // Ensure groups is always an array even on error
            } finally {
                setIsLoading(false);
            }
        };

        fetchGroups();
    }, []);

    return { groups, isLoading, error };
};
